import { FC, PropsWithChildren } from 'react';

import { Card, Text } from '@servicetitan/anvil2';

interface SectionCardProps extends PropsWithChildren {
    title: string;
}

export const SectionCard: FC<SectionCardProps> = ({ children, title }) => (
    <Card flexDirection="column" padding="medium">
        <Text variant="headline" el="h3" size="small" className="m-b-3-i">
            {title}
        </Text>
        {children}
    </Card>
);
